import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { FriendlyPublicLayout } from './components/Layout/FriendlyPublicLayout';
import { LandingPage } from './pages/Home/LandingPage';
import { FriendlyEventList } from './pages/Events/FriendlyEventList';
import { FriendlyEventDetail } from './pages/Events/FriendlyEventDetail';
import { FriendlyTeamDetail } from './pages/Events/FriendlyTeamDetail';
import { FriendlyLiveScores } from './pages/Scores/FriendlyLiveScores';
import { FriendlyMatchCenter } from './pages/Scores/FriendlyMatchCenter';
import { FriendlyPrivacyPolicyPage } from './pages/Legal/FriendlyPrivacyPolicyPage';
import { FriendlyAccountDeletionPage } from './pages/Legal/FriendlyAccountDeletionPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<FriendlyPublicLayout />}>
          <Route index element={<LandingPage />} />
          <Route path="events" element={<FriendlyEventList />} />
          <Route path="events/:id" element={<FriendlyEventDetail />} />
          <Route path="events/:id/teams/:teamId" element={<FriendlyTeamDetail />} />
          <Route path="scores" element={<FriendlyLiveScores />} />
          <Route path="scores/matches/:matchId" element={<FriendlyMatchCenter />} />
          <Route path="privacy" element={<FriendlyPrivacyPolicyPage />} />
          <Route path="account/delete" element={<FriendlyAccountDeletionPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
